import React from "react";
import { Input } from "reactstrap";
import { toast } from "react-toastify";
import useUser from "../../hooks/use-user";
import Button from "../components/Button/index";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";

const Login = () => {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
    });

    const navigate = useNavigate();
    const { login } = useUser();

    const onSubmitLogin = (credentials) => {
        login(credentials)
            .then(() => navigate("/dashboard"))
            .catch(notify);
    };

    const notify = (message) => {
        toast(message, {
            type: "error",
            position: "bottom-right",
        });
    };

    return (
        <div>
            <div>
                <img className="imagenBanner img-fluid" src="https://socimedicostools.com/recursos/img/banner/banner.jpg" alt="Clínica San Rafael" title="Clínica San Rafael"/>
                <h1 className="tituloBanner text-center text-white">
                    Centro de Apoyo Nuevo
                </h1>
            </div>
            <div className="block-center mt-4 wd-xl">
                <div className="card card-flat">
                    <div className="card-header text-center">
                        <h4>
                            Ingreso a Centro de Apoyo Nuevo
                        </h4>
                    </div>
                    <div className="card-body">
                        <form
                            className="mb-3"
                            onSubmit={handleSubmit(onSubmitLogin)}
                        >
                            <div className="form-group">
                                <div className="input-group with-focus">
                                    <Controller
                                        name="email"
                                        control={control}
                                        rules={{
                                            required: "El campo Email es requerido",
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                placeholder="Usuario"
                                                type="text"
                                                invalid={errors.email != null}
                                                value={field.value ?? ""}
                                                {...field}
                                            />
                                        )}
                                    />

                                    <div className="input-group-append">
                                        <span className="input-group-text text-muted bg-transparent border-left-0">
                                            <em className="fa fa-envelope"></em>
                                        </span>
                                    </div>
                                    {errors.email && (
                                        <span className="invalid-feedback">
                                            {errors.email.message}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group with-focus">
                                    <Controller
                                        name="password"
                                        control={control}
                                        rules={{
                                            required:
                                                "El campo password es requerido",
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                placeholder="Contraseña"
                                                type="password"
                                                invalid={errors.password != null}
                                                {...field}
                                            />
                                        )}
                                    />

                                    <div className="input-group-append">
                                        <span className="input-group-text text-muted bg-transparent border-left-0">
                                            <em className="fa fa-lock"></em>
                                        </span>
                                    </div>
                                    {errors.password && (
                                        <span className="invalid-feedback">
                                            {errors.password.message}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="clearfix">
                                <div className="float-right">
                                    <Link to="/recover" className="text-muted">
                                        ¿Olvidaste tú contraseña?
                                    </Link>
                                </div>
                            </div>
                            <Button type="submit" className="mt-3 bg-secondary">
                                Iniciar Sesión
                            </Button>
                        </form>
                    </div>
                </div>
                <div className="fixed-bottom bg-dark p-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9 col-sm-12">
                                <img src="https://socimedicostools.com/recursos/img/icontec/iso9001.png" width="80" height="100" alt="ISO 9001" title="ISO 9001"/>
                                <img src="https://socimedicostools.com/recursos/img/icontec/iso14001.png" width="80" height="100" alt="ISO 14001" title="ISO 14001"/>
                                <img src="https://socimedicostools.com/recursos/img/icontec/teletrabajo.png" width="100" height="100" alt="Teletrabajo" title="Teletrabajo"/>
                            </div>
                            <div className="col-md-3 col-sm-12 text-white">
                                <div>
                                    <strong>
                                        <h3>
                                            SOCIMEDICOS S.A.S.
                                        </h3>
                                        <h4>
                                            www.ipsclinicasanrafael.com
                                        </h4>
                                        <h4>
                                            +57 60(6) 3115411
                                        </h4>
                                    </strong>
                                </div>
                                <div >
                                    <i className="fab fa-instagram m-1"></i>
                                    <i className="fab fa-facebook-square m-1"></i>
                                    <i className="fab fa-youtube m-1"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
